import React, { useState } from "react";
import "./casestudies.css";
import { motion } from "framer-motion";
// import useAOS from "../AosLoader";

import img1 from "../assests/case-img1.jpeg";
import img2 from "../assests/case-img2.png";
import img3 from "../assests/case-img3.jpeg";
import img4 from "../assests/case-img4.png";
import img5 from "../assests/case-img5.jpeg";
import img6 from "../assests/case-img6.jpeg";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import emailjs from "@emailjs/browser";
import {
    EMAILJS_SERVICE_ID,
    EMAILJS_CONTACT_TEMPLATE_ID,
    EMAILJS_AUTOREPLY_TEMPLATE_ID,
    EMAILJS_PUBLIC_KEY,
} from "../emailjsConfig";

/* ---------------- FILTER DROPDOWN ---------------- */

interface FilterDropdownProps {
    title: string;
    options: string[];
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
    title,
    options,
}) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="filter-group">
            <div
                className="filter-header"
                onClick={() => setOpen((prev) => !prev)}
            >
                <span>{title}</span>
                <i
  className={`fas ${
    open ? "fa-chevron-up" : "fa-chevron-down"
  }`}
/>
            </div>

            {open && (
                <div className="filter-dropdown">
                    {options.map((item, i) => (
                        <label key={i} className="filter-option">
                            <input type="checkbox" />
                            <span>{item}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

/* ---------------- MAIN COMPONENT ---------------- */

const CaseStudies: React.FC = () => {
    //   useAOS();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [demoData, setDemoData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        service: "",
        message: "",
    });
    const [isDemoSubmitting, setIsDemoSubmitting] = useState(false);

    const handleBookDemo = async () => {
        try {
            setIsDemoSubmitting(true);
            const params = {
                name: `${demoData.firstName} ${demoData.lastName}`.trim(),
                mail: demoData.email,
                from_email: demoData.email,
                phonenumber: demoData.phone,
                subject: `Book a Demo - ${demoData.service}`,
                address: "",
                message: demoData.message,
            };
            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_CONTACT_TEMPLATE_ID,
                params,
                { publicKey: EMAILJS_PUBLIC_KEY }
            );
            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_AUTOREPLY_TEMPLATE_ID,
                params,
                { publicKey: EMAILJS_PUBLIC_KEY }
            );
            setDemoData({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                service: "",
                message: "",
            });
            setIsModalOpen(false);
            alert("Your demo request has been sent. We'll reach out soon!");
        } catch (err) {
            alert("Something went wrong. Please try again.");
        } finally {
            setIsDemoSubmitting(false);
        }
    };

    const caseStudies = [
        {
            img: img1,
            metric: "37%",
            metricText: "faster decision-making",
            title: "Mining Operation",
            desc: "A leading mining operation managing high-volume extraction activities across...",
        },
        {
            img: img2,
            metric: "18%",
            metricText: "reduction in energy costs",
            title: "Major University Campus",
            desc: "A leading university operating a large and diverse campus committed...",
        },
        {
            img: img3,
            metric: "35%",
            metricText: "reduction in travel costs",
            title: "Oil & Gas Producer",
            desc: "A prominent oil and gas producer managing operations across remote...",
        },
        {
            img: img4,
            metric: "32%",
            metricText: "improvement in system uptime",
            title: "Water Treatment Facility",
            desc: "A regional water treatment facility dedicated to delivering safe water through...",
        },
        {
            img: img5,
            metric: "15%",
            metricText: "increase in OEE",
            title: "Global Food Manufacturer",
            desc: "A leading global packaged food manufacturer supplying high-demand...",
        },
        {
            img: img6,
            metric: "30%",
            metricText: "faster error detection",
            title: "Automotive System Mapping",
            desc: "A global leader in automotive software faced challenges in visualising...",
        },
    ];

    const filterData = {
        Technology: [
            "AI / ML",
            "AR / VR",
            "Analytics",
            "Cloud",
            "IoT",
            "Web 3.0"
        ],
        Industry: [
            "Automotive & Mobility",
            "Energy / Utility",
            "Finance",
            "Healthcare",
            "Manufacturing"
        ],

        Solutions: [
            "B2B eCommerce",
            "System Mapping",
            "iSERV",
            "iSAT"
        ],
        UseCase: [
            "Digital Transformation",
            "ERP",
            "Predictive Maintenance",
            "Smart Infrastructure"
        ],
    };

    return (
        <>
            <div className="hd">
                <Header />
            </div>
            
            <section className="case-hero" data-aos="fade-up">
                <div className="case-overlay" />
                <div className="container case-hero-content">
                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="case-title"
                    >
                        Case Studies
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="case-subtitle"
                    >
                        Driving Digital Change with Proven Solutions
                    </motion.p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="case-layout" data-aos="fade-up">
                {/* FILTER */}
                <aside className="case-filter">
                    <button className="filter-btn active">All</button>

                    <FilterDropdown
                        title="Technology"
                        options={filterData.Technology}
                    />

                    <FilterDropdown
                        title="Industry / Vertical"
                        options={filterData.Industry}
                    />

                    <FilterDropdown
                        title="Solutions"
                        options={filterData.Solutions}
                    />

                    <FilterDropdown
                        title="Use Case"
                        options={filterData.UseCase}
                    />
                </aside>

                {/* CARDS */}
                <div className="case-cards mx-2">
                    {caseStudies.map((item, i) => (
                        <div className="case-card mx-2" key={i}>
                            <div className="case-img">
                                <img src={item.img} alt={item.title} />

                                <div className="case-metric-overlay">
                                    <h3>{item.metric}</h3>
                                    <p>{item.metricText}</p>
                                </div>

                                <div className="case-blue-strip" />
                            </div>

                            <h4>{item.title}</h4>
                            <p className="case-desc">{item.desc}</p>

                            <button
                                className="case-readmore"
                                onClick={() => setIsModalOpen(true)}
                            >
                                Book a Demo <i className="fas fa-play" />
                            </button>
                        </div>
                    ))}
                </div>
            </section>

            {isModalOpen && (
                <div
                    className="book-demo-overlay"
                    onClick={(e) => e.target === e.currentTarget && setIsModalOpen(false)}
                >
                    <div className="book-demo-modal">
                        <div className="book-demo-header">
                            <div>
                                <h2>Book a Demo</h2>
                                <p>Fill in your details and we'll get back to you within 24 hours.</p>
                            </div>
                            <button
                                className="book-demo-close"
                                onClick={() => setIsModalOpen(false)}
                                aria-label="Close"
                            >
                                &times;
                            </button>
                        </div>

                        <div className="book-demo-body">
                            <div className="book-demo-row">
                                <div className="book-demo-group">
                                    <label>First Name</label>
                                    <input
                                        type="text"
                                        placeholder="John"
                                        value={demoData.firstName}
                                        onChange={(e) =>
                                            setDemoData({ ...demoData, firstName: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="book-demo-group">
                                    <label>Last Name</label>
                                    <input
                                        type="text"
                                        placeholder="Doe"
                                        value={demoData.lastName}
                                        onChange={(e) =>
                                            setDemoData({ ...demoData, lastName: e.target.value })
                                        }
                                    />
                                </div>
                            </div>

                            <div className="book-demo-group">
                                <label>Work Email</label>
                                <input
                                    type="email"
                                    placeholder="john@company.com"
                                    value={demoData.email}
                                    onChange={(e) =>
                                        setDemoData({ ...demoData, email: e.target.value })
                                    }
                                />
                            </div>

                            <div className="book-demo-group">
                                <label>Phone Number</label>
                                <input
                                    type="tel"
                                    placeholder="+1 (555) 000-0000"
                                    value={demoData.phone}
                                    onChange={(e) =>
                                        setDemoData({ ...demoData, phone: e.target.value })
                                    }
                                />
                            </div>

                            <div className="book-demo-group">
                                <label>Service Interested In</label>
                                <select
                                    value={demoData.service}
                                    onChange={(e) =>
                                        setDemoData({ ...demoData, service: e.target.value })
                                    }
                                >
                                    <option value="" disabled>Select a service</option>
                                    <option>Web Design</option>
                                    <option>Web Development</option>
                                    <option>SEO &amp; Marketing</option>
                                    <option>Other</option>
                                </select>
                            </div>

                            <div className="book-demo-group">
                                <label>Message (Optional)</label>
                                <textarea
                                    placeholder="Tell us about your project..."
                                    rows={3}
                                    value={demoData.message}
                                    onChange={(e) =>
                                        setDemoData({ ...demoData, message: e.target.value })
                                    }
                                />
                            </div>

                            <button
                                className="theme-btn w-100 mt-10"
                                onClick={handleBookDemo}
                                disabled={isDemoSubmitting}
                            >
                                {isDemoSubmitting ? "Sending..." : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
};

export default CaseStudies;
